import { render } from "./GoalFinishDateActivity.vue?vue&type=template&id=1827061a"
import script from "./GoalFinishDateActivity.vue?vue&type=script&lang=js"
export * from "./GoalFinishDateActivity.vue?vue&type=script&lang=js"
script.render = render

export default script